import {
    MapOptions
} from "esdm-map/dist";
import { HighlandBaseLayerTypes } from "./HighlandBaseMapping_27700";

export class DefaultMapOptions {

    public static GetDefaultOptions(
        mapElementId: string,
        mapStoreKey: string
    ): MapOptions {       

        let opt = new MapOptions();       
        opt.bingApiKey = $(`#${mapElementId}`).data("bing-api-key");
        opt.esdmOsmApiKey = $(`#${mapElementId}`).data("esdm-osm-api-key");
        opt.baseMaps = [HighlandBaseLayerTypes.BingAerial, HighlandBaseLayerTypes.HighlandOS];        
        opt.defaultBaseMap = HighlandBaseLayerTypes.HighlandOS;
        opt.enableBoundsTracking = true;
        opt.zoomToNearestBounds = false;
        opt.maxZoomToBounds = 12;
        opt.mapElementId = mapElementId;
        opt.mapStoreKey = mapStoreKey;
        opt.mapZoom = 8;
        opt.minZoom = 3;
        opt.maxZoom = 16;
        //opt.extent = [-751000, 7630000, -299766, 8151166];
        //opt.mapCentre = [-460658.38234629954, 7780630.30000752];                
        //opt.displayProjection = "EPSG:3857";

        opt.extent = [106941.85, 728518.25, 360137.25, 997666.43];
        opt.mapCentre = [
            260345, 841798
        ];    

        opt.displayProjection = "EPSG:27700";
        opt.dataProjection = "EPSG:27700";
        opt.dragRotateAndZoom = false;                
        return opt;
    }

}
